import { render } from "./UserQuestionnaire.vue?vue&type=template&id=71c5bae6&scoped=true&ts=true"
import script from "./UserQuestionnaire.vue?vue&type=script&lang=ts"
export * from "./UserQuestionnaire.vue?vue&type=script&lang=ts"

import "./UserQuestionnaire.vue?vue&type=style&index=0&id=71c5bae6&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c5bae6"]])

export default __exports__